import React from 'react';
import PropTypes from 'prop-types';

const TrackVisualFocus = ({onEnter, onExit, children}) =>
  <div onMouseEnter={onEnter}
       onMouseLeave={onExit}
       onFocus={onEnter}
       onBlur={onExit} >
    {children}
  </div>;

TrackVisualFocus.propTypes = {
  'onEnter': PropTypes.func,
  'onExit': PropTypes.func,
  'children': PropTypes.element.isRequired
};

export default TrackVisualFocus;
